import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TextField, Typography, CircularProgress } from '@mui/material';

const fieldSx = {
    backgroundColor: '#f7f7f7',
    '& .MuiOutlinedInput-root': {
        '& fieldset': { border: 'none' },
        '&:hover fieldset': { border: 'none' },
        '&.Mui-focused fieldset': { border: 'none' },
        '& input::placeholder': {
            fontSize: '0.8rem',
            fontWeight: '300',
        },
    },
};

const sectionLabelSx = {
    fontSize: '0.8rem',
    fontWeight: 600,
    color: '#4f4f4f',
    marginBottom: '10px',
    marginTop: '5px',
};

const charCountSx = {
    width: '100%',
    textAlign: 'right',
    pl: 0,
    ml: 0,
    marginLeft: 0,
    mt: 0.5,
    mb: 2,
    color: '#828282',
    fontSize: '0.7rem',
    display: 'block',
};

/**
 * CustomLabelEditor - Responsive UI for editing custom tab labels
 * @param {object} props
 * @param {object} props.labels - Current custom labels (key-value pairs)
 * @param {function} props.onChange - Called with updated labels object
 * @param {Array} props.defaultLabels - Array of { key, label } for each tab
 * @param {boolean} [props.loading] - Show spinner if saving
 */
const TeamCustomLabelEditor = ({ labels, onChange, defaultLabels, loading }) => {
    // Handler for input change
    const handleInputChange = (key, value) => {
        if (value.length > 50) return; // Enforce max length
        onChange({ ...labels, [key]: value });
    };

    return (
        <>
            <Typography variant="body2" sx={sectionLabelSx}>
                Customize Tab Labels
            </Typography>
            <Grid container spacing={2} sx={{ marginTop: 0 }}>
                {defaultLabels.map(tab => (
                    <Grid item xs={12} sm={6} key={tab.key}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder={tab.key}
                            value={labels[tab.key] ?? ''}
                            onChange={e => handleInputChange(tab.key, e.target.value)}
                            inputProps={{ maxLength: 50 }}
                            size="small"
                            sx={fieldSx}
                        />
                        <Typography variant="caption" sx={charCountSx}>
                            {(labels[tab.key] || '').length}/50 characters
                        </Typography>
                    </Grid>
                ))}
                {loading && (
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <CircularProgress size={24} />
                    </Grid>
                )}
            </Grid>
        </>
    );
};

TeamCustomLabelEditor.propTypes = {
    labels: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    defaultLabels: PropTypes.arrayOf(
        PropTypes.shape({ key: PropTypes.string.isRequired, label: PropTypes.string.isRequired })
    ).isRequired,
    loading: PropTypes.bool,
};

export default TeamCustomLabelEditor; 